module.exports = __webpack_public_path__ + "static/media/active-calls.9ef9626d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/active-calls.svg
// module id = 876
// module chunks = 0